import actionTypes from '../actionTypes';

export function requestClubTables() {
  return {
    type: actionTypes.REQUEST_CLUB_TABLES
  };
}

export function successClubTables  ( tableList ) {
  return {
    type: actionTypes.CLUB_TABLES_SUCCESS,
    tableList
  };
}
export function resetClubTables () {
  return {
    type: actionTypes.RESET_CLUB_TABLES
  };
}

export function failClubTables  () {
  return {
    type: actionTypes.TABLES_FAILURE
  };
}

export function requestCreateTable({ params, history }) {
  return {
    type: actionTypes.CREATE_TABLE_REQUEST,
    params,
    history
  };
}

export function successCreateTable() {
  return {
    type: actionTypes.CREATE_TABLE_SUCCESS
  };
}
